<template>
	<b-modal
		ref="specimen-incidences-modal"
		:title="getTitle"
		centered
		v-model="isActive"
		@hidden="handleHidden"
		size="xsmd"
		hide-footer
	>
		<b-tabs>
			<b-tab lazy>
				<template #title>
					<span class="text-capitalize">Regulares</span>
					<b-badge variant="danger" v-if="counters.regular" class="ml-1">
						{{ counters.regular }}
					</b-badge>
				</template>
				<TableIncidence :info="info" />
			</b-tab>
			<b-tab lazy>
				<template #title>
					<span class="text-capitalize">Preparación</span>
					<b-badge variant="danger" v-if="counters.preparation" class="ml-1">
						{{ counters.preparation }}
					</b-badge>
				</template>
				<PreparationIncidencesTable :info="info" />
			</b-tab>
		</b-tabs>
	</b-modal>
</template>

<script>
import TableIncidence from "@/views/amg/header-bookmarks/incidences/TableIncidence.vue"
import PreparationIncidencesTable from "@/views/amg/videolibrary/incidences/PreparationIncidencesTable.vue"
import PreparacionService from "@/services/preparacion/default.service.js"
export default {
	components: { TableIncidence, PreparationIncidencesTable },
	props: {
		show: Boolean,
		info: Object,
	},
	data() {
		return {
			isActive: false,
			isLoading: false,
			incidences: [],
			counters: {
				regular: 0,
				preparation: 0,
			},
		}
	},
	async created() {},
	computed: {
		getTitle() {
			return `Incidencias del ejemplar ${this.info.alias ? this.info.alias : ""} ${this.info.alias ? "/" : ""} (${
				this.info.plate ? this.info.plate : ""
			})`
		},
	},
	methods: {
		async getIncidencesCounter() {
			const { data } = await PreparacionService.getIncidencesCounterBySpecimenId(this.info.id)
			this.counters = data
		},
		handleHidden() {
			this.isActive = false
			this.isLoading = false
			this.$emit("closing")
		},
	},
	watch: {},
	async mounted() {
		await this.getIncidencesCounter()
		this.$refs["specimen-incidences-modal"].toggle()
	},
}
</script>

<style lang="scss" scoped></style>
